import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { Button, Table } from 'reactstrap';
import { translate } from "react-translate";
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import { actionSetEditAsset, actionDeleteAsset } from 'store/actions/assetsActions';
import { actionGetKitTypes } from 'store/actions/kitsActions';

//Sweet alert
import SweetAlert from "react-bootstrap-sweetalert";
import { actionSweetAlert } from "store/actions/commonActions";

const TableAssets = (props) => {
    const { data, loading, page, callback } = props;
    const { t } = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const kitTypes = useSelector(state => state.kitsReducer.types);

    const editAsset = (e, asset) => {
        e.preventDefault();
        dispatch(actionSetEditAsset({...asset}));
        history.push(`/admin/assets/form/${asset._id}`);
    }

    const deleteAsset = (e, asset) => {
        e.preventDefault();

        dispatch(
            actionSweetAlert(
                <SweetAlert
                    warning
                    title={`Are you sure you want to delete asset: ${asset.type}(${asset.brand}) ?`}
                    onConfirm={() => {
                        dispatch(actionDeleteAsset(asset._id));
            
                        /* Go back to the previous page if the current page has no data after deletion*/
                        if (data.length === 1 && page > 0) {
                            callback(page - 1);
                        }
            
                        dispatch(actionSweetAlert(null));
                    }}
                    onCancel={() => dispatch(actionSweetAlert(null))}
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="info"
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    All the data related to it will be lost!
                </SweetAlert>
            )
        );
    }

    useEffect(() => {
        if (!Object.keys(kitTypes).length) {
            dispatch(actionGetKitTypes());
        }
    }, []);

    return (
        <>
            {loading ?
                (<LoadingLocal />)
                :
                (<div className="table-data">
                    <Table>
                        <thead>
                            <tr>
                                <th> {t("status")}</th>
                                <th> {t("identifier")}</th>
                                <th> {t("type")}</th>
                                <th> {t("brand")}</th>
                                <th> {t("model")}</th>
                                <th> {t("created")} </th>
                                <th> {t("actions")} </th>
                                <th></th>
                            </tr>
                        </thead>

                        {data.length > 0 && (data.map((p, index) => {
                            return (
                                <tbody key={index}>
                                    <tr>
                                        <th>{t(p.status)}</th>
                                        <th>{p.identifier}</th>

                                        <th>
                                            {p.asset_type}
                                            {p.asset_type === "device" ? (<>
                                                <br/>
                                                <small>{p.study_type}</small>
                                            </>) : (<></>)}
                                        </th>

                                        <th>{p.brand}</th>
                                        <th>{p.model}</th>
                                        <th>{p.created_at}</th>
                                        <th>
                                            {p.status !== "deleted" ? <>
                                                <Button
                                                    onClick={e => editAsset(e, p)}
                                                    className="btn-icon btn-round"
                                                    color="warning"
                                                    size="md"
                                                >
                                                    <i className="fa fa-edit" />
                                                </Button>
                                                <Button
                                                    onClick={e => deleteAsset(e, p)}
                                                    className="btn-icon btn-round"
                                                    color="danger"
                                                    size="md"
                                                >
                                                    <i className="fa fa-times" />
                                                </Button>
                                            </> : <></>}
                                        </th>
                                    </tr>
                                </tbody>
                            )
                        })
                        )}
                    </Table>
                </div>)}

        </>
    );
};
TableAssets.defaultProps = {
    data: [],
    loading: true
};

TableAssets.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
};

export default translate("assets")(TableAssets);